import { render } from "./ClientSecretsManager.vue?vue&type=template&id=45adc3c7&scoped=true"
import script from "./ClientSecretsManager.vue?vue&type=script&lang=js"
export * from "./ClientSecretsManager.vue?vue&type=script&lang=js"

import "./ClientSecretsManager.vue?vue&type=style&index=0&id=45adc3c7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45adc3c7"]])

export default __exports__